import type { Sticker } from '../types';

export const valentines: Sticker[] = [
  {
    id: 18001,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/001-letter.png',
    name: 'List Miłosny',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18002,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/002-rainbow.png',
    name: 'Tęcza',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18003,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/003-chatting.png',
    name: 'Wiadomość',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18004,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/004-ring.png',
    name: 'Pierścionek',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18005,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/005-wine.png',
    name: 'Wino',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18006,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/006-gift.png',
    name: 'Prezent',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18007,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/007-tea.png',
    name: 'Herbata',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18008,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/008-heart lock.png',
    name: 'Kłódka Miłości',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18009,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/009-perfume.png',
    name: 'Perfumy',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18010,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/010-gift.png',
    name: 'Prezent Walentynkowy',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18011,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/011-ice cream.png',
    name: 'Lody',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18012,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/012-gumball machine.png',
    name: 'Automat z Gumami',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18013,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/013-heart.png',
    name: 'Serce',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18014,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/014-chocolate.png',
    name: 'Czekolada',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18015,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/015-lollipop.png',
    name: 'Lizak',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18016,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/016-love bird.png',
    name: 'Ptaszek Miłości',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18017,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/017-letter box.png',
    name: 'Skrzynka na Listy',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18018,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/018-key lock.png',
    name: 'Klucz do Serca',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18019,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/019-broken heart.png',
    name: 'Złamane Serce',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18020,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/020-love letter.png',
    name: 'List Walentynkowy',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18021,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/021-candle.png',
    name: 'Świeczka',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18022,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/022-cupid bow.png',
    name: 'Łuk Amora',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18023,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/023-bouquet.png',
    name: 'Bukiet',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18024,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/024-love bird.png',
    name: 'Gołąbki',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18025,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/025-wine.png',
    name: 'Wino Musujące',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18026,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/026-cassette tape.png',
    name: 'Kaseta',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18027,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/027-coconut drink.png',
    name: 'Drink Kokosowy',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18028,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/028-romantic music.png',
    name: 'Muzyka Romantyczna',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18029,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/029-target.png',
    name: 'Cel Amora',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18030,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/030-plant.png',
    name: 'Roślina',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18031,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/031-hourglass.png',
    name: 'Klepsydra',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18032,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/032-plant.png',
    name: 'Kwiat w Doniczce',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18033,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/033-chatting.png',
    name: 'Czat',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18034,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/034-shopping.png',
    name: 'Zakupy',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18035,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/035-emoji.png',
    name: 'Emoji',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18036,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/036-location.png',
    name: 'Lokalizacja',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18037,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/037-bell.png',
    name: 'Dzwonek',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18038,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/038-snow globe.png',
    name: 'Kula Śnieżna',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18039,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/039-mirror.png',
    name: 'Lustro',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18040,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/040-love potion.png',
    name: 'Eliksir Miłości',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18041,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/041-call.png',
    name: 'Telefon',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18042,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/042-plant.png',
    name: 'Roślina w Sercu',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18043,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/043-care.png',
    name: 'Opieka',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18044,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/044-love.png',
    name: 'Miłość',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18045,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/045-cats.png',
    name: 'Zakochane Koty',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18046,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/046-give love.png',
    name: 'Dawanie Miłości',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18047,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/047-cage.png',
    name: 'Klatka',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18048,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/048-love song.png',
    name: 'Piosenka o Miłości',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 18049,
    url: 'https://stickers.nauczniaczek.pl/colections/14260189-valentines-day-stickers/png/049-lovers.png',
    name: 'Zakochani',
    category: 'valentines',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];